export function price (value: number, override: boolean) {
  if (value === 0 && override === false) {
    return 'INCL.' + override // TODO translation
  } else {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
      .format(value)
      .replace(',00', ',=')
  }
}
